var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"background":'red-100'}},[_c('div',{staticClass:"w-full flex flex-col items-center justify-center"},[_c('x-circle-icon',{attrs:{"width":70,"height":70,"color":'red-700'}}),_vm._t("title",function(){return [_c('h4',[_vm._v("Error")])]}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }